import React from 'react';
import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import SearchIcon from '@material-ui/icons/Search';
import HeaderMenu from './HeaderMenu';

const MainMenu = ({ menus }) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      flex={1}
      paddingLeft="20px"
      paddingRight="12px"
    >
      <HeaderMenu
        menus={menus}
        isParentMenu
        activeBorderWidth={4}
        activeBorderColor="#fff"
        style={{ color: '#fff', fontWeight: 600 }}
      />
      <Link to={`/search`}>
        <Tooltip title="Search shipments" arrow placement="bottom">
          <IconButton style={{ color: '#fff' }} data-testid="header-search-button">
            <SearchIcon />
          </IconButton>
        </Tooltip>
      </Link>
    </Box>
  );
};

export default MainMenu;
